import * as React from 'react';
import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuContent from '../MenuContent/MenuContent';
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";

const DRAWER_WIDTH = 22.5; // spacing units (180px at default 8px base)
const NAVBAR_HEIGHT = 64;

const Drawer = styled(MuiDrawer)(({ theme }) => `
    box-sizing: border-box;
    display: none;
    flex-shrink: 0;
    width: ${theme.spacing(DRAWER_WIDTH)};

    & .${drawerClasses.paper} {
        background-color: ${theme.palette.background.paper};
        background-image: none;
        box-sizing: border-box;
        height: calc(100% - ${NAVBAR_HEIGHT}px);
        top: ${NAVBAR_HEIGHT}px;
        width: ${theme.spacing(DRAWER_WIDTH)};
    }

    ${theme.breakpoints.up('md')} {
        display: block;
    }
`);

export default function SideMenu() {
    return (
        <Drawer variant="permanent">
            <Divider />
            <MenuContent />
        </Drawer>
    );
}
